import clsx from 'clsx'

import RatingDownIcon from '@/assets/img/ico-rate-down.svg?react'
import RatingUpIcon from '@/assets/img/ico-rate-up.svg?react'
import OrderCreateIcon from '@/assets/img/orders-create-icon.svg?react'
import RevenueIcon from '@/assets/img/revenue-icon.svg?react'
import SaleIcon from '@/assets/img/sales-revunue.svg?react'
import TrendChart from '@/compoments/charts/TrendChart'
import type { KPI } from '@/types/executives'
import type JobStatistics from '../../ExecutivesDashboardPage/parts/JobStatistics'

const JobStatistic = ({ data }: { data?: KPI }) => {
    const jobStatistics: JobStatistics[] = [
        {
            label: 'Technicians',
            icon: <RevenueIcon />,
            trend: Number(data?.technicians?.changed) >= 0 ? 'up' : 'down',
            value: data?.technicians.value || 0,
            percent: Number(data?.technicians.changed) || 0,
        },
        {
            label: 'Order Volume',
            icon: <OrderCreateIcon />,
            trend: Number(data?.orderVolume?.changed) >= 0 ? 'up' : 'down',
            value: data?.orderVolume.value || 0,
            percent: Number(data?.orderVolume.changed) || 0,
        },
        {
            label: 'Sales Revenue',
            icon: <SaleIcon />,
            trend: Number(data?.salesRevenue?.changed) >= 0 ? 'up' : 'down',
            value: data?.salesRevenue.value || 0,
            percent: Number(data?.salesRevenue.changed) || 0,
        },
    ]
    return (
        <div className="col-12">
            <div className="row gutters-18">
                {jobStatistics.map((item, index) => (
                    <div key={index} className="col-xl-4 col-md-6 col-12">
                        <div className="card card-shadow card-seo">
                            <div className="card-body">
                                <div className="card-seo-info flex-shrink-0">
                                    <div className="seo-title">
                                        <span className="ico">{item.icon}</span>
                                        <span className="name">
                                            {item.label}
                                        </span>
                                    </div>
                                    <h1 className="seo-stat-title">
                                        {item.value}
                                    </h1>
                                </div>
                                <div
                                    className="card-seo-chart"
                                    style={{
                                        height: 60,
                                        width: 100,
                                    }}
                                >
                                    <TrendChart trend={item.trend} />
                                </div>
                            </div>
                            <div className="card-footer">
                                <div className="seo-rating-row">
                                    <div
                                        className={clsx(
                                            'seo-rating',
                                            `--${item.trend}`,
                                        )}
                                    >
                                        <span className="ico">
                                            {item.trend === 'up' ? (
                                                <RatingUpIcon />
                                            ) : (
                                                <RatingDownIcon />
                                            )}
                                        </span>{' '}
                                        <span>
                                            {item.trend === 'up' ? '+' : '-'}
                                            {item.percent}%
                                        </span>
                                    </div>
                                    <p className="seo-rating-desk">
                                        <span>vs</span> yesterday
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    )
}

export default JobStatistic
